module.exports = __webpack_public_path__ + "static/media/231-libya.f3883f98.svg";